export const ACTION_GET_CUSTOMER_REVIEWS_AVERAGE = '/ProductReviews/GetCustomerReviewsOverview';